import { MigrationSpec } from "../migration.models"

const actionLegacyChannelScope: MigrationSpec = {
  type: "CLEAR_ACTION_LEGACY_CHANNEL_SCOPE",
  collection: "Actions",
  risk: "SAFE",
  title: {
    en: "Custom actions → usable on every channel",
    tr: "Özel aksiyonlar → her kanalda kullanılabilir"
  },
  description: {
    en:
      "Copies `channelIds` to `legacyChannelIds` and empties `channelIds` on every CUSTOM action " +
      "saved while the action form still asked for channels. An empty scope means every channel; " +
      "TEMPLATE actions keep their channel.",
    tr:
      "Aksiyon formu kanal sorarken kaydedilmiş her CUSTOM aksiyonda `channelIds` değerini " +
      "`legacyChannelIds` alanına kopyalar ve `channelIds`'i boşaltır. Boş kapsam her kanal " +
      "demektir; TEMPLATE aksiyonları kanallarını korur."
  },
  // Copied literally from ACTION_LEGACY_CHANNEL_SCOPE_FILTER in api-v2's Action/core/action.constants.ts.
  affectedFilter: { type: "CUSTOM", "channelIds.0": { $exists: true } },
  sampleFields: ["customer", "name", "channelIds"],
  preview: (doc) => ({
    ...doc,
    channelIds: [],
    legacyChannelIds: doc.channelIds
  }),
  notes: [
    {
      en:
        "The form has not shown or edited this scope since 2026-08-20, so a tenant cannot see why " +
        "an action never runs on WhatsApp. Bella Maison's order lookup was one (2026-10-20).",
      tr:
        "Form bu kapsamı 2026-08-20'den beri göstermiyor ve düzenletmiyor; tenant bir aksiyonun " +
        "WhatsApp'ta neden hiç çalışmadığını göremez. Bella Maison'un sipariş sorgusu bunlardan biriydi (2026-10-20)."
    },
    {
      en: "Reversible per action: the old scope stays in `legacyChannelIds`.",
      tr: "Aksiyon bazında geri alınabilir: eski kapsam `legacyChannelIds` alanında kalır."
    }
  ]
}

export default actionLegacyChannelScope
